import { render, staticRenderFns } from "./PayeeDashboard.vue?vue&type=template&id=780ae0f2&scoped=true"
import script from "./PayeeDashboard.vue?vue&type=script&lang=js"
export * from "./PayeeDashboard.vue?vue&type=script&lang=js"
import style0 from "./PayeeDashboard.vue?vue&type=style&index=0&id=780ae0f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780ae0f2",
  null
  
)

export default component.exports